import React, { FC, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { openModalByName, Link } from 'ia-react-core';
import { useDispatch } from 'react-redux';
import { getOnpremHostname } from 'omni-package-react-core';
import { Helmet } from 'react-helmet';
import { ReactComponent as ErrorIcon } from '../../assets/Robot-error.svg';
import {
  StyledErrorMessage, StyledIcon, StyledParagraph,
  StyledTitle,
  StyledWrapper,
  StyledLink,
} from './AccessErrorPage.styles';
import { getIdpTenantUrl } from '../../utils/getIdpTenantUrl';

export interface AccessErrorPageProps { }
export interface AccessErrorComposedProps {
  title: string;
  titlePrefix: string;
}

const AccessErrorPage: FC<AccessErrorComposedProps> = ({ title, titlePrefix }) => {
  const { t } = useTranslation('AccessErrorPage');
  const dispatch = useDispatch();
  const url = `${getIdpTenantUrl()}login/signout?fromURI=${getOnpremHostname()}/eemwpnp1/public/gologin/`;
  const handleClickNousContacter = useCallback(() => {
    dispatch(openModalByName('needHelp'));
  }, [dispatch]);
  const message1 = t('message1');
  const message3 = t('message3');
  const message4 = t('message4');
  const message5 = t('message5');
  return (
    <>
      <Helmet><title>{title}</title></Helmet>
      <StyledWrapper>
        <StyledErrorMessage>
          <StyledIcon as={ErrorIcon} id="logoError" />
          <StyledTitle data-testid="accessErrorTitle">{t('title')}</StyledTitle>
          <StyledParagraph data-testid="accessErrorMessage">
            {message1}<br></br>{titlePrefix}
            <StyledLink><Link id="linkEspaceClient" href={url}>{title}</Link></StyledLink>
            {message3}
            <StyledLink><Link id="linkNousContacter" role="button" onClick={handleClickNousContacter}>{message4}</Link></StyledLink>
            {message5}
          </StyledParagraph>
        </StyledErrorMessage>
      </StyledWrapper>
    </>
  );
};
export default AccessErrorPage;
